module.exports = __webpack_public_path__ + "img/kort-2.d565b945.png";